import { YANADOO_AI_HOST } from 'common/config'

const CS_CDN_HOST = 'https://english.yanadoocdn.com/upload/yanadoo/new/cs/'
const AI_FAQ_CHAT = `${YANADOO_AI_HOST}/faq/chat`
const AI_FAQ_KEYWORD = `${YANADOO_AI_HOST}/faq/ai-keyword-top5`
const AI_QNA_CHAT = `${YANADOO_AI_HOST}/qna`
const AI_QNA_ENTER = `${YANADOO_AI_HOST}/qna/id`
export const CS_CONFIG = { CS_CDN_HOST, AI_FAQ_CHAT, AI_QNA_CHAT, AI_QNA_ENTER, AI_FAQ_KEYWORD }
